module.exports = __webpack_public_path__ + "static/media/education2@2x.326b8739.png";